// robots.service.ts
import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class RobotsService {
  private readonly meta = inject(Meta);

  setNoIndex(): void {
    this.meta.updateTag(
      {
        name: 'robots',
        content: 'noindex,follow',
      },
      "name='robots'",
    );
  }

  setIndexable(): void {
    // No tag means the normal default: index, follow.
    this.meta.removeTag("name='robots'");
  }
}